/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Join_BoardInputs */

const en_directory_vibebids_join_board = /** @type {(inputs: Directory_Vibebids_Join_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the board`)
};

const zh_directory_vibebids_join_board = /** @type {(inputs: Directory_Vibebids_Join_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入榜单`)
};

/**
* | output |
* | --- |
* | "Join the board" |
*
* @param {Directory_Vibebids_Join_BoardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_join_board = /** @type {((inputs?: Directory_Vibebids_Join_BoardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Join_BoardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_join_board(inputs)
	return zh_directory_vibebids_join_board(inputs)
});
export { directory_vibebids_join_board as "directory.vibebids.join_board" }